var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowershell2SvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: -2.176,
    cy: -852.913,
    r: 48.27,
    gradientTransform: "matrix(0.36, 0.402, 0.222, -0.163, 205.356, -126.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ce1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7ce1ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 4199.973,
    cy: -1221.763,
    r: 83.239,
    gradientTransform: "matrix(0.031, 0.03, 0.075, -0.062, -25.785, -180.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ce1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ce1ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: -264.938,
    cy: -543.943,
    r: 27.886,
    gradientTransform: "matrix(-1.048, -0.5, -1.117, 0.527, -867.609, 176.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ce1ff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#7ce1ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -113.501,
    y1: -375.465,
    x2: -113.501,
    y2: -404.611,
    gradientTransform: "matrix(1, 0, 0, -1, 129.5, -387.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_powershell2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.492,5.6H28.335a1.517,1.517,0,0,1,1.546,1.948L25.958,24.454a2.636,2.636,0,0,1-2.45,1.948H3.665a1.517,1.517,0,0,1-1.546-1.948L6.042,7.545A2.636,2.636,0,0,1,8.492,5.6Z",
    style: {
      fill: "#2a80c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.508,26.471H3.665a1.653,1.653,0,0,1-1.333-.6,1.657,1.657,0,0,1-.279-1.436L5.976,7.53a2.71,2.71,0,0,1,2.516-2H28.335a1.584,1.584,0,0,1,1.612,2.031L26.024,24.47A2.71,2.71,0,0,1,23.508,26.471ZM8.492,5.664a2.568,2.568,0,0,0-2.384,1.9L2.185,24.47a1.525,1.525,0,0,0,.253,1.321,1.521,1.521,0,0,0,1.227.544H23.508a2.568,2.568,0,0,0,2.384-1.9L29.815,7.53a1.45,1.45,0,0,0-1.48-1.866Z",
    style: {
      fill: "#1f5e93",
      opacity: 0.9451000094413757
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.541,26.359H3.7A1.57,1.57,0,0,1,2.433,25.8a1.574,1.574,0,0,1-.263-1.364L6.093,7.522A2.514,2.514,0,0,1,8.459,5.641H28.3A1.5,1.5,0,0,1,29.83,7.568L25.907,24.477A2.514,2.514,0,0,1,23.541,26.359ZM8.459,5.843A2.336,2.336,0,0,0,6.29,7.568L2.367,24.477a1.376,1.376,0,0,0,.224,1.192,1.372,1.372,0,0,0,1.107.487H23.541a2.336,2.336,0,0,0,2.168-1.725L29.633,7.522A1.3,1.3,0,0,0,28.3,5.843Z",
    style: {
      fill: "#bbd8f1",
      opacity: 0.9451000094413757
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.558,15.816c.061-.183-7-7.561-7-7.561",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: "76.71700286865234px",
      stroke: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.558,22.835s9.942-6.825,10-7",
    style: {
      fill: "#2aa7c9",
      strokeLinecap: "round",
      strokeWidth: "76.71700286865234px",
      stroke: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73,23.121H9.854",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 100,
      stroke: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.817,24.052a1.226,1.226,0,0,1-.7-2.237c2.77-1.9,6.941-4.786,8.809-6.117-1.253-1.385-3.8-4.088-5.665-6.046A1.226,1.226,0,1,1,13.041,7.96c.017.017,1.674,1.756,3.3,3.493C17.3,12.475,18.065,13.3,18.61,13.9c.334.368.583.649.76.856a1.514,1.514,0,0,1,.494,1.539c-.165.492-.165.492-5.428,4.142-2.438,1.691-4.9,3.383-4.926,3.4A1.221,1.221,0,0,1,8.817,24.052Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.925,23.929H15.043a1.226,1.226,0,0,1,0-2.453h4.882a1.226,1.226,0,1,1,0,2.453Z",
    style: {
      fill: "#ffffff",
      opacity: 0.75,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.606,13.04c-10.079.433-19.226,2.533-25.181,5.78L2.118,24.454A1.514,1.514,0,0,0,3.664,26.4H23.507a2.629,2.629,0,0,0,2.45-1.948L28.605,13.04Z",
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.492,5.6a2.629,2.629,0,0,0-2.45,1.948L2.118,24.455A1.514,1.514,0,0,0,3.664,26.4H23.507a2.629,2.629,0,0,0,2.45-1.948L29.88,7.545A1.514,1.514,0,0,0,28.334,5.6H8.492Z",
    style: {
      fill: "url(#d)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowershell2SvgrepoCom);
export default __webpack_public_path__ + "static/media/powershell2-svgrepo-com.e48e8562fdb0a3ea0c35b4bde7230485.svg";
export { ForwardRef as ReactComponent };